import { companiesResource } from '@Resources/companies';
import { ResourceDefinition } from '@Utils/types';

export const dashboardResource: ResourceDefinition = {
  ...companiesResource,
  options: {
    label: 'menu.dashboard',
  },
};
